module.exports = __webpack_public_path__ + "components/country-flag/static/nl-5b27b397e38072b6c9f47356ccc8c4b6.svg";